import React from 'react';
import Script from 'next/script';
import { Typography } from '@mui/material';
export default function SabeeAppComponent(props) {
    const id = props.props.id;
    const src_link = "https://ibe.sabeeapp.com/bewidget.php?id=" + id;
    const widget_id = "widget_" + id;
    return (React.createElement(React.Fragment, null, id ? (React.createElement(React.Fragment, null,
        React.createElement(Script, { id: widget_id, src: src_link }),
        React.createElement("div", { id: widget_id }))) : (React.createElement(Typography, null, "SabeeApp Booking ID is empty"))));
}
//# sourceMappingURL=SabeeAppComponent.js.map